
export const isBusinessDay = (date: Date) => {
  const day = date.getDay();
  return day !== 0 && day !== 6;
};

const toDayStart = (date: Date) =>
  new Date(date.getFullYear(), date.getMonth(), date.getDate());

export const countBusinessDaysBetween = (startDateValue?: string, endDateValue?: string) => {
  if (!startDateValue || !endDateValue) {
    return 0;
  }

  const startDate = new Date(startDateValue);
  const endDate = new Date(endDateValue);

  if (Number.isNaN(startDate.getTime()) || Number.isNaN(endDate.getTime())) {
    return 0;
  }

  if (endDate <= startDate) {
    return 0;
  }

  const startDay = toDayStart(startDate);
  const endDay = toDayStart(endDate);

  if (startDay.getTime() === endDay.getTime()) {
    return 0;
  }

  let businessDays = 0;
  const cursor = new Date(startDay);
  cursor.setDate(cursor.getDate() + 1);

  while (cursor <= endDay) {
    if (isBusinessDay(cursor)) {
      businessDays += 1;
    }
    cursor.setDate(cursor.getDate() + 1);
  }

  return businessDays;
};